import moment from "moment";
import React, {useEffect, useMemo, useRef, useState} from "react";
import './QuestionDatePicker.css';
import {NassauLog} from "../../scripts/myga-utils";

const populateOptions = (type, start, end, inc) => {
  if (!Number.isInteger(start)) start = Number.parseInt(start);
  if (!Number.isInteger(end)) end = Number.parseInt(end);
  if (!Number.isInteger(inc)) inc = Number.parseInt(inc);
  let options = [];
  options.push(<option key={`${type}_ns`} value=''>--</option>);
  for (let i=start; i<=end; i+=inc) {
    let s = (i<10)?'0'+i:''+i;
    options.push(<option key={`${type}_${i}`} value={s}>{s}</option>)
  }
  return options;
}

const reverseOptions = (options) => {
  let reversedOptions = [...options];
  let defaultValue = reversedOptions.splice(0,1);
  reversedOptions.reverse();
  reversedOptions = [defaultValue, ...reversedOptions];
  return reversedOptions;
}


export default function QuestionDatePicker(props) {
  const {required, handleChange, question, data, responseClass} = props;

  const {maxDate, minDate, dateFormat, yearOrderAscending} = question.response.constraints[0];
  const maxYear = useMemo(() => moment(maxDate).format('YYYY'),[maxDate]);
  const minYear = useMemo(() => moment(minDate).format('YYYY'),[minDate]);

  const initialDate = useRef(moment(data[question.key], dateFormat));
  const [dateValues, setDateValues] = useState((() => {
    if (initialDate.current.isValid()) {
      return {
        month:initialDate.current.format('MM'),
        day:initialDate.current.format('DD'),
        year:initialDate.current.format('YYYY')
      }
    }
    return {month:'',day:'',year:''}
  })());

  useEffect(() => {
    const dateFilledOut = (dateValues.year !== '' && dateValues.month !== '' && dateValues.day !== '');

    // Check if the date is pre-populated
    if (!initialDate.current.isValid() && !dateFilledOut) return;

    let pickedDateStr = `${dateValues.year}-${dateValues.month}-${dateValues.day}`;
    let pickedDate = moment(pickedDateStr, 'YYYY-MM-DD');

    // Check if the date is the same as the pre-populated date
    if (initialDate.current.isValid() && dateFilledOut && pickedDate.isValid() &&
      initialDate.current.format(dateFormat) === pickedDate.format(dateFormat)) return

    // Check if complete date is filled out
    if (dateFilledOut && pickedDate.isValid()) {
      handleChange(question.key)(pickedDate.format(dateFormat));
      return
    }

    handleChange(question.key)('');
  }, [dateValues, handleChange, question.key, dateFormat]);

  const renderSelect = useMemo(() => (type, options, value) => {
    const handleDateValueChange = type => e => {
      setDateValues(previousState => ({...previousState, [type]: e.target.value}));
    }

    return (
      <select key={`${type}_sel`}
              id={`${type}_sel`}
              className={`form-control page-input ${type}`}
              value={value}
              onChange={handleDateValueChange(type)}
              required={required}>
        {options}
      </select>
    )
  }, [required]);

  const renderMonth = useMemo(() => {
    let options = populateOptions('month', 1, 12, 1);
    return renderSelect('month', options, dateValues.month);
  }, [dateValues.month, renderSelect])

  const renderDay = useMemo(() => {
    let options = populateOptions('day', 1, 31, 1);
    return renderSelect('day', options, dateValues.day);
  }, [dateValues.day, renderSelect]);

  const renderYear = useMemo(() => {
    let options = populateOptions('year', minYear, maxYear, 1);
    options = yearOrderAscending ? options : reverseOptions(options);
    return renderSelect('year', options, dateValues.year);
  },[dateValues.year, maxYear, minYear, renderSelect, yearOrderAscending]);

  return (
    <div className={`nsre-date-picker ${responseClass}`}>
      <div className={'row'}>
        <div className={'select-wrap col-4'}>
          {renderMonth}
          <div><label>month</label></div>
        </div>
        <div className={'select-wrap col-4'}>
          {renderDay}
          <div><label>day</label></div>
        </div>
        <div className={'select-wrap col-4'}>
          {renderYear}
          <div><label>year</label></div>
        </div>
      </div>
    </div>
  )
}